"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _sweetalert = _interopRequireDefault(require("sweetalert2"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var showDialog = function showDialog(props) {
  var title = props.title,
      text = props.text,
      link = props.link,
      type = props.type,
      html = props.html,
      showCancelButton = props.showCancelButton,
      confirmButtonText = props.confirmButtonText,
      cancelButtonText = props.cancelButtonText;
  var clickable = link && "<a href=".concat(link, " target=\"_blank\" rel=\"noopener noreferrer\">").concat(link, "</a>");
  return (0, _sweetalert["default"])({
    title: title,
    text: text,
    type: type,
    html: html || clickable,
    showCancelButton: showCancelButton || false,
    confirmButtonText: confirmButtonText || 'Ok',
    cancelButtonText: cancelButtonText || 'Cancel',
    confirmButtonClass: 'button--primary',
    cancelButtonClass: 'button--secondary',
    customClass: 'swal-global'
  });
};

showDialog.propTypes = {
  title: _propTypes["default"].string,
  text: _propTypes["default"].string,
  type: _propTypes["default"].string,
  html: _propTypes["default"].object,
  showCancelButton: _propTypes["default"].bool,
  confirmButtonText: _propTypes["default"].string,
  cancelButtonText: _propTypes["default"].string,
  confirmButtonClass: _propTypes["default"].string,
  cancelButtonClass: _propTypes["default"].string,
  customClass: _propTypes["default"].string
};
showDialog.defaultProps = {
  showCancelButton: false,
  confirmButtonText: 'Ok',
  cancelButtonText: 'Cancel'
};
var _default = showDialog;
exports["default"] = _default;